export const shippingSkipPackingValues = {
  skip: 'skip',
  pack: 'pack',
}

export const shippingSkipPackingOptions = [
  {
    value: shippingSkipPackingValues.pack,
    label: 'Abrir la pantalla de empaquetado al preparar envíos',
  },
  {
    value: shippingSkipPackingValues.skip,
    label: 'Omitir la pantalla de empaquetado y marcar todos los productos como empaquetados',
  },
]
